import { RequestKind, string } from '@sb/library/base';
import { ApiRoute } from '../api-route';

export namespace AssetsRoutes {
    export namespace Images {
        export const Get = ApiRoute.Define({
            URL: (src: string) => `${src}`,
            Kind: RequestKind.Get,
            ResultType: string
        });
    }
}
